export function sameMicrosoftTenant(a, b) {
    return Boolean(a) && Boolean(b) && a.toLowerCase() === b.toLowerCase();
}

export function copilotHoldsTenant(connections, tenantId) {
    return (connections ?? []).some(
        (connection) => connection.status === "connected" && sameMicrosoftTenant(connection.entraTenantId, tenantId),
    );
}

export function directoryHoldsTenant(directories, tenantId) {
    return (directories ?? []).some(
        (directory) =>
            directory.provider === "ENTRA_ID" &&
            directory.status !== "deleting" &&
            Boolean(tenantId) &&
            directory.boundDirectoryId === tenantId,
    );
}
